import { render, staticRenderFns } from "./ImpresoraBanner.vue?vue&type=template&id=825038bc&scoped=true"
import script from "./ImpresoraBanner.vue?vue&type=script&lang=js"
export * from "./ImpresoraBanner.vue?vue&type=script&lang=js"
import style0 from "./ImpresoraBanner.vue?vue&type=style&index=0&id=825038bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825038bc",
  null
  
)

export default component.exports